import React from 'react';
import { motion } from 'framer-motion';

const spring = { type: 'spring', stiffness: 300, damping: 22 };

export function FolderIcon({ accentColor = '#007AFF', label, sublabel, onClick, isActive, size = 128 }) {
  const s  = size / 128;
  const W  = size, H = size;
  const R  = Math.round(32 * s);
  const flapBg    = `${accentColor}44`;
  const paperBack = `${accentColor}28`;
  const paperLine = `${accentColor}60`;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: Math.round(8 * s), cursor: 'pointer' }} onClick={onClick}>
      <div style={{
        borderRadius: R + 4, padding: 3,
        boxShadow: isActive ? `0 0 0 2.5px ${accentColor}` : '0 0 0 2.5px transparent',
        transition: 'box-shadow 0.15s',
      }}>
      <motion.div
        initial="rest" whileHover="hover" animate="rest"
        variants={{ rest: {}, hover: {} }}
        style={{
          position: 'relative', width: W, height: H, borderRadius: R,
          overflow: 'hidden', flexShrink: 0,
          background: `linear-gradient(to bottom, ${accentColor}cc, ${accentColor})`,
          borderTop: '2px solid rgba(255,255,255,0.32)',
        }}
      >
        {/* Front flap */}
        <div style={{ position: 'absolute', right: 0, bottom: 0, left: 0, zIndex: 20 }}>
          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <div style={{ width: Math.round(48*s), height: Math.round(16*s), borderTopLeftRadius: Math.round(8*s), background: flapBg,
              backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)' }}/>
            <div style={{ width: Math.round(10*s), height: Math.round(16*s), borderTopRightRadius: R, background: flapBg,
              backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)' }}/>
            <div style={{
              width: Math.round(10*s), height: Math.round(10*s), background: flapBg,
              WebkitMaskImage: 'radial-gradient(200% 200% at 100% 0%, transparent 50%, black 50%)',
              maskImage: 'radial-gradient(200% 200% at 100% 0%, transparent 50%, black 50%)',
            }}/>
          </div>
          <div style={{ height: Math.round(48*s), borderTopRightRadius: Math.round(12*s), background: flapBg,
            backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)' }}/>
        </div>

        {/* Papers */}
        <div style={{ position: 'absolute', left: Math.round(24*s), right: Math.round(24*s), top: Math.round(12*s), zIndex: 10 }}>
          <motion.div variants={{ rest: { rotate: 4, y: 0, transition: spring }, hover: { rotate: 6, y: -5, transition: spring } }}
            style={{ originY: 1, position: 'absolute', left: 0, right: 0, top: Math.round(6*s), height: Math.round(96*s), borderRadius: Math.round(16*s), background: paperBack }}/>
          <motion.div variants={{ rest: { rotate: -4, y: 0, transition: spring }, hover: { rotate: -6, y: -5, transition: spring } }}
            style={{ originY: 1, position: 'absolute', left: 0, right: 0, top: Math.round(6*s), height: Math.round(96*s), borderRadius: Math.round(16*s), background: paperBack }}/>
          <motion.div variants={{ rest: { y: 0, transition: spring }, hover: { y: -3, transition: spring } }}
            style={{ position: 'absolute', left: 0, right: 0, top: 0, height: Math.round(96*s), borderRadius: Math.round(12*s),
              borderTop: `1px solid ${accentColor}30`, background: '#ffffff' }}>
            <div style={{ paddingTop: Math.round(12*s), paddingLeft: Math.round(12*s), paddingRight: Math.round(12*s), display: 'flex', flexDirection: 'column', gap: Math.round(5*s) }}>
              <div style={{ height: Math.round(4*s), width: '72%', borderRadius: 999, background: paperLine }}/>
              <div style={{ height: Math.round(4*s), width: '48%', borderRadius: 999, background: paperLine }}/>
              <div style={{ height: Math.round(4*s), width: '60%', borderRadius: 999, background: paperLine }}/>
            </div>
          </motion.div>
        </div>

        {/* Session count badge */}
        {sublabel && (
          <div style={{ position: 'absolute', bottom: Math.round(12*s), left: Math.round(10*s), zIndex: 20,
            background: 'rgba(0,0,0,0.20)', borderRadius: 999, padding: `2px ${Math.round(8*s)}px` }}>
            <span style={{ fontSize: Math.max(7, Math.round(9*s)), fontWeight: 600, color: '#fff', letterSpacing: 0.2 }}>{sublabel}</span>
          </div>
        )}
      </motion.div>
      </div>

      {/* Name below folder */}
      {label && (
        <div style={{ textAlign: 'center', maxWidth: W }}>
          <div style={{ fontSize: Math.round(13*s), fontWeight: 600, color: '#000', letterSpacing: -0.2,
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: W }}>
            {label}
          </div>
        </div>
      )}
    </div>
  );
}
